import { render, staticRenderFns } from "./PendingMentorshipRequestsTable.vue?vue&type=template&id=0aba5ca4&scoped=true&"
import script from "./PendingMentorshipRequestsTable.vue?vue&type=script&lang=js&"
export * from "./PendingMentorshipRequestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba5ca4",
  null
  
)

export default component.exports